import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Login from './pages/Login';
import Callback from './pages/Callback';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import Solutions from './pages/Solutions';
import Maintainers from './pages/Maintainers';
import AmazonSQS from './pages/AmazonSQS';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <NotificationProvider>
      <AuthProvider>
        <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<Callback />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/tenants"
            element={
              <PrivateRoute>
                <Tenants />
              </PrivateRoute>
            }
          />
          <Route
            path="/tenants/:tenantId"
            element={
              <PrivateRoute>
                <TenantDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/solutions"
            element={
              <PrivateRoute>
                <Solutions />
              </PrivateRoute>
            }
          />
          <Route
            path="/maintainers"
            element={
              <PrivateRoute>
                <Maintainers />
              </PrivateRoute>
            }
          />
          <Route
            path="/amazon-sqs"
            element={
              <PrivateRoute>
                <AmazonSQS />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
      </AuthProvider>
    </NotificationProvider>
  );
}

export default App;

